<template>
  <div :class="$utilModalStyle.modalOverlay" @click="closeModal">
    <div :class="[$utilModalStyle.modalContent, $style.winnersModalContent]" @click.stop>
      <h3 :class="$style.title">{{ $t('winners-title') }}</h3>
      <div :class="$style.subTitle">{{ $t('winners-subtitle') }}</div>
      <div :class="$style.body">
        <div :class="$style.groupsList">
          <div v-for="group in groups" :key="group.id" :class="$style.groupItem">
            <div :class="$style.groupHeader">
              <div :class="$style.groupName">{{ group.name }}</div>
            </div>
            <div :class="$style.resultContainer">
              <img
                :class="$style.resultAvatar"
                :src="group.winner === 'Saboteur' ? theaterImg : group.winner === 'Players' ? teamImg : handshakeImg"
                :alt="group.winner === 'Saboteur' ? 'Saboteur' : group.winner === 'Players' ? 'Players' : $t('no-saboteur')"
              />
              <div :class="$style.resultName">
                {{ group.winner === "Saboteur" ? $t('saboteur') : group.winner === "Players" ? $t('players') : $t('no-saboteur') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :class="$utilModalStyle.modalActions">
        <!-- <button :class="$utilModalStyle.secondaryAction" @click="closeModal">I'll Wait</button> -->
        <button :class="$utilModalStyle.primaryAction" @click="props.closeModal">{{ $t('close') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/WinnersModal.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import TeamImg from "@/assets/team.png";
import TheaterImg from "@/assets/theater.png";
import HandshakeImg from "@/assets/handshake.png";

const $style = styles;
const $utilModalStyle = utilModalStyles;
const teamImg = TeamImg;
const theaterImg = TheaterImg;
const handshakeImg = HandshakeImg;

// eslint-disable-next-line
const props = defineProps({
  closeModal: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped></style>
